import { CheckOutlined, ReloadOutlined } from '@ant-design/icons';
import { Button, ConfigProvider, Input, message } from 'antd';
import { observer } from 'mobx-react-lite';
import { twMerge } from 'tailwind-merge';
import AiGenTip from '../../../components/aiGenTip';
import { summaryStore } from '../store';

// 毕业论文第二步
const GraduationThesisStep2 = () => {
    // 检查选中的标题是否超过50字
    const isTitleTooLong = () => {
        const selectedIdx = summaryStore.qy.selectIdx;
        if (selectedIdx >= 0 && summaryStore.qy.titles[selectedIdx]) {
            return summaryStore.qy.titles[selectedIdx].length > 50;
        }
        return false;
    };

    // 处理下一步按钮点击
    const handleNextStep = () => {
        if (isTitleTooLong()) {
            message.warning('标题过长（50字限制），请修改或选用推荐标题');
            return;
        }
        summaryStore.step2Submit();
    };

    return (
        <div className="border border-[#f0f0f0] bg-white pb-8">
            <div className="mt-4 text-center text-[#999]">给文章选择一个亮眼的标题吧～</div>
            <div className="p-[30px_32px]">
                {summaryStore.qy.titles?.map((title, idx) => {
                    const isSel = summaryStore.qy.selectIdx === idx;
                    const isFocus = summaryStore.qy.focusIdx === idx;
                    const titleLength = title ? title.length : 0;
                    const isOverLimit = titleLength > 50;

                    return (
                        <div
                            key={idx}
                            className={twMerge(
                                'mb-2 flex items-center justify-start rounded border border-transparent bg-white p-[15px]',
                                'hover:shadow-[0_1px_4px_rgba(68,90,116,0.25)]',
                                isFocus && 'border-[rgba(0,145,255,0.66)]',
                                isSel && 'border-primary bg-[#EBD8FF]',
                                isOverLimit && isSel && 'border-[#ff4d4f]',
                            )}
                        >
                            <div className="flex-1">
                                <Input.TextArea
                                    placeholder={idx === 0 ? '自定义标题' : ''}
                                    bordered={false}
                                    value={title}
                                    onFocus={() => summaryStore.setFocusIdx(idx)}
                                    onBlur={() => summaryStore.setFocusIdx(-1)}
                                    onChange={(e) => summaryStore.step2Change(idx, e.target.value)}
                                    maxLength={200}
                                    autoSize={true}
                                    readOnly={summaryStore.qy.nextLoading}
                                    status={isOverLimit ? 'error' : ''}
                                />
                                <div
                                    className={`mr-4 text-right text-xs ${isOverLimit ? 'text-[#ff4d4f]' : 'text-[#999]'}`}
                                >
                                    {titleLength}/50
                                </div>
                            </div>
                            {isSel ? (
                                <CheckOutlined className="px-[30px] text-2xl text-primary" />
                            ) : (
                                <Button
                                    disabled={!title || summaryStore.qy.nextLoading}
                                    onClick={() => summaryStore.step2Select(idx)}
                                >
                                    <CheckOutlined />
                                    选择
                                </Button>
                            )}
                        </div>
                    );
                })}
                <div className="flex justify-center">
                    {summaryStore.qy.nextLoading ? null : (
                        <Button
                            type={'text'}
                            className="mt-5"
                            onClick={() => summaryStore.step1Submit()}
                        >
                            <ReloadOutlined className="-translate-y-0.5 text-primary" />
                            <span className="text-primary">重新生成</span>
                        </Button>
                    )}
                </div>
            </div>
            <div className="flex justify-center gap-4">
                <ConfigProvider
                    theme={{
                        components: {
                            Button: {
                                defaultBg: '#fff',
                            },
                        },
                    }}
                >
                    <Button
                        disabled={summaryStore.qy.nextLoading}
                        onClick={() => summaryStore.setCurrentStep(0)}
                        className="h-[48px] w-[208px]"
                    >
                        上一步
                    </Button>
                    <Button
                        className="h-[48px] w-[208px]"
                        type="primary"
                        onClick={handleNextStep}
                        disabled={summaryStore.qy.selectIdx <= -1}
                        loading={summaryStore.qy.nextLoading}
                    >
                        下一步
                    </Button>
                </ConfigProvider>
            </div>
            <AiGenTip />
        </div>
    );
};

export default observer(GraduationThesisStep2);
